import { ApolloError, ApolloQueryResult } from '@apollo/client';
import {
  ShipmentFragment,
  ShipmentQuery,
  useShipmentQuery,
} from '@shared/generated/graphql';
import { shipmentFromFragment } from '@shared/graphql/fromFragments/shipment';
import { Shipment } from '../../types/shipment';

type UseShipmentDetailsProps = {
  shipmentId: string;
};

export type ShipmentDetails = {
  shipment: Shipment;
  isLoading: boolean;
  error?: ApolloError;
  refetch: () => Promise<ApolloQueryResult<ShipmentQuery>>;
};

export function useShipmentDetails(
  props: UseShipmentDetailsProps
): ShipmentDetails {
  const result = useShipmentQuery({ variables: { id: props.shipmentId } });

  const { data, loading, error, refetch } = result;
  const details: ShipmentFragment | undefined = data?.shipmentById;
  const shipment = shipmentFromFragment(details);
  return {
    shipment,
    isLoading: loading,
    error,
    refetch,
  };
}
